import { authenticatedUser } from 'header-scripts';
import supportModule from '../supportModule';

function supportController(
  $log,
  $q,
  $scope,
  supportService,
  modalService,
  languageResource,
  regexService,
  captchaV2Constants,
  resources
) {
  'ngInject';

  $scope.getAccountInfo = function () {
    supportService.getMetaData(resources.apiSets.getAccountInfoUrl.url).then(
      function (data) {
        $scope.accountContent.userInfo = {
          data,
          hasError: false
        };
        $scope.$broadcast('onPageMetaDataInit');
      },
      function (error) {
        $scope.accountContent.userInfo = {
          data: error,
          hasError: true
        };
      }
    );
  };

  $scope.getExistenceCurrentAge13AndOver = function () {
    const storage = localStorage.getItem('currentAge13AndOver');
    if (!storage) {
      return false;
    }
    const expireTime = JSON.parse(storage).expiresAt;
    if (Date.parse(new Date()) > Date.parse(expireTime)) {
      localStorage.removeItem('currentAge13AndOver');
      $scope.existenceCurrentAge13AndOver = false;
      return false;
    }
    return true;
  };

  $scope.getCurrentAge13AndOver = function () {
    const storage = localStorage.getItem('currentAge13AndOver');
    return JSON.parse(storage).age13AndOver;
  };

  $scope.init = function init() {
    $scope.formSubmitting = false;
    $scope.ageGateSubmitted = false;
    $scope.ageGateAge13AndOver = false;
    $scope.isEligibleForChat = false;

    $scope.existenceCurrentAge13AndOver = $scope.getExistenceCurrentAge13AndOver();
    $scope.currentAge13AndOver = $scope.existenceCurrentAge13AndOver
      ? $scope.getCurrentAge13AndOver()
      : true;
    $scope.userAge13AndOver = $scope.currentAge13AndOver;
    $scope.getEmailString = '';
    if ($scope.existenceCurrentAge13AndOver) {
      $scope.getEmailString = $scope.currentAge13AndOver
        ? languageResource.get('Label.EmailAddress')
        : languageResource.get('Label.ParentEmailAddress');
    }

    $scope.$on('onAgeGateSubmitted', function () {
      $scope.ageGateSubmitted = true;
      $scope.existenceCurrentAge13AndOver = true;
    });
    $scope.$on('onAgeGateAge13AndOverTrue', function () {
      $scope.ageGateAge13AndOver = true;
      $scope.userAge13AndOver = true;
      $scope.currentAge13AndOver = true;
      $scope.getEmailString = languageResource.get('Label.EmailAddress');
    });
    $scope.$on('onAgeGateAge13AndOverFalse', function () {
      $scope.ageGateAge13AndOver = false;
      $scope.userAge13AndOver = false;
      $scope.currentAge13AndOver = false;
      $scope.getEmailString = languageResource.get('Label.ParentEmailAddress');
    });

    $scope.$on('onChatEligibilityTrue', function (event, supportFormPartialScope) {
        $scope.isEligibleForChat = true;
        $scope.$broadcast('onEligibleToLoadSierraSDK', supportFormPartialScope);
    });

    $scope.accountContent = {
      userInfo: {}
    };

    $scope.supportFormScope = {
      accountContent: $scope.accountContent,
      supportTicket: {}
    };

    supportService.getMetaData(resources.apiSets.getMetadataUrl.url).then(function (data) {
      $scope.pageMetaData = data;
      $scope.pageMetaData.authenticated = false;
      if (authenticatedUser.isAuthenticated) {
        $scope.pageMetaData.authenticated = true;
        $scope.userAge13AndOver = !authenticatedUser.isUnder13;
        $scope.getEmailString = !authenticatedUser.isUnder13
          ? languageResource.get('Label.EmailAddress')
          : languageResource.get('Label.ParentEmailAddress');
        $scope.getAccountInfo();
      }
    });
  };

  $scope.init();
}

supportModule.controller('supportController', supportController);

export default supportController;
